import { useController } from 'react-hook-form';

import TextField from '@mui/material/TextField';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';

interface CustomDateInputProps {
  source: string;
  label: string;
  timeOnly?: boolean;
  minDate?: Date;
}

export const CustomDateInput = ({ source, label, minDate, timeOnly }: CustomDateInputProps) => {
  const dateInput = useController({ name: source, defaultValue: null });

  return timeOnly ? (
    <DesktopTimePicker
      {...dateInput.field}
      label={label}
      renderInput={(params: any) => {
        return (
          <TextField
            data-cy={source}
            fullWidth
            error
            variant="outlined"
            {...params}
            helperText={dateInput.fieldState.error?.message}
          />
        );
      }}
    />
  ) : (
    <DesktopDatePicker
      {...dateInput.field}
      label={label}
      inputFormat="DD/MM/YYYY"
      minDate={minDate}
      renderInput={(params) => {
        return (
          <TextField
            data-cy={source}
            fullWidth
            error
            variant="outlined"
            {...params}
            helperText={dateInput.fieldState.error?.message}
          />
        );
      }}
    />
  );
};
